export default __webpack_public_path__ + "static/media/job6.f0cfff9b.svg";